import { render } from "./KFooter.vue?vue&type=template&id=1fb7b53d&scoped=true"
import script from "./KFooter.vue?vue&type=script&lang=js"
export * from "./KFooter.vue?vue&type=script&lang=js"

import "./KFooter.vue?vue&type=style&index=0&id=1fb7b53d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb7b53d"]])

export default __exports__